import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { AxiosResponse } from 'axios';
import { API } from 'network/api';
import { PaddyBuyer } from 'types/common';
import { MutationConfig, PaddyBuyerPayload } from 'types/request';
import { handleAxiosError } from 'utils/helpers';

type MutatePaddyBuyerConfig = Omit<MutationConfig, 'onSuccess'> & {
  onSuccess?: (data: AxiosResponse<PaddyBuyer>) => Promise<unknown> | void;
  method?: 'POST' | 'PUT';
};

const useMutatePaddyBuyer = (config?: MutatePaddyBuyerConfig) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (data: PaddyBuyerPayload) =>
      API.request({
        url: `/paddy-buyers${config?.method === 'PUT' && data.id ? '/' + data.id : ''}`,
        data,
        method: config?.method ?? 'POST',
      }),
    onSuccess: async (data) => {
      queryClient.removeQueries({
        queryKey: ['farmer-group', 'paddy-buyer', 'paddy-buyer-by-id'],
      });
      await config?.onSuccess?.(data);
      message.success(
        config?.method === 'PUT'
          ? 'Paddy Buyer changes has been saved successfully.'
          : 'Stakeholder added successfully.',
      );
    },
    onError: (error) => {
      config?.onError?.();
      handleAxiosError(
        error,
        config?.method === 'PUT'
          ? 'Failed to save changes to Paddy Buyer. Please try again.'
          : 'Failed to add Paddy Buyer. Please try again',
      );
    },
    onSettled: () => {
      config?.onFinish?.();
    },
  });

  return mutation;
};

export default useMutatePaddyBuyer;
